// @ts-strict-ignore
import { TSection } from '@/shared/types/deprecated-types'

export const getCategoryParents = (categories: TSection[], currentCategory: TSection): TSection[] => {
	if (!currentCategory || !currentCategory.parentId) {
		return []
	}

	try {
		const parentCategory = categories.find(category => category.id === currentCategory.parentId)
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		const { title, code, link } = parentCategory
		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		return [...getCategoryParents(categories, parentCategory), { title, code, link }]
	} catch {
		return []
	}
}
